import { render, staticRenderFns } from "./customTabNav.vue?vue&type=template&id=3eb6bf05&"
import script from "./customTabNav.vue?vue&type=script&lang=js&"
export * from "./customTabNav.vue?vue&type=script&lang=js&"
import style0 from "./customTabNav.vue?vue&type=style&index=0&id=3eb6bf05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./customTabNav.vue?vue&type=custom&index=0&blockType=customTabNav&%3AtabList=tabList&%3AselectTab=currentTab&%40change=tabChange"
if (typeof block0 === 'function') block0(component)

export default component.exports